import React, { useState, memo, useEffect } from "react";
import { Card, List } from "antd";
import Meta from "antd/es/card/Meta";
import { useNavigate } from "react-router-dom";

import styles from "./template.module.css";
import { TextComponent } from "../../../../components";

import img1 from "../../../../assets/staticImages/templates/template1.png";
import img2 from "../../../../assets/staticImages/templates/template2.png";
import img3 from "../../../../assets/staticImages/templates/template3.png";
import img4 from "../../../../assets/staticImages/templates/template4.png";
import img5 from "../../../../assets/staticImages/templates/template5.png";
import img6 from "../../../../assets/staticImages/templates/template6.png";
import img7 from "../../../../assets/staticImages/templates/template7.png";
import img8 from "../../../../assets/staticImages/templates/template8.png";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../../Store/Middlewares/EventPlanningMiddleware";

const data = [
  {
    title: "Flower Delight",
    img: img1,
  },
  {
    title: "Blue Heaven",
    img: img2,
  },
  {
    title: "Colorful Temp",
    img: img3,
  },
  {
    title: "Teal Magic",
    img: img4,
  },
  {
    title: "Elegant",
    img: img5,
  },
  {
    title: "Soft Template",
    img: img6,
  },
  {
    title: "Artistic",
    img: img7,
  },
  {
    title: "Floral",
    img: img8,
  },
  {
    title: "Flower Delight",
    img: img1,
  },
  {
    title: "Blue Heaven",
    img: img2,
  },
  {
    title: "Colorful Temp",
    img: img3,
  },
  {
    title: "Teal Magic",
    img: img4,
  },
  {
    title: "Elegant",
    img: img5,
  },
  {
    title: "Soft Template",
    img: img6,
  },
  {
    title: "Artistic",
    img: img7,
  },
  {
    title: "Floral",
    img: img8,
  },
];

const RenderItem = memo(({ item }) => {
  const navigate = useNavigate();
  return (
    <List.Item
      onClick={() => {
        navigate("/templates/template", { state: { data: item } });
      }}
    >
      <img className={styles.image} src={item?.image} alt="example" />
      <TextComponent textClass={styles.textClass} text={item?.name} />
    </List.Item>
  );
});

function Template() {
  
  const Templates = useSelector(state => state.EventPlanningReducer.Templates);
// console.log("templates//////////", Templates);
  const dispatch= useDispatch()

  useEffect(() => {
        dispatch(EventPlanningMiddleware.getTemplates())
            // .then(() => setTloading(false))
            // .catch(() => setTloading(false))

}, [])


  return (
    <List
      className={styles.listClass}
      grid={{
        xs: 1,
        sm: 2,
        md: 2,
        lg: 3,
        xl: 4,
        xxl: 4,
      }}
      dataSource={Templates}
      renderItem={(item) => <RenderItem item={item} />}
    />
  );
}

export default Template;
